import { useEffect, useState } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import styled from '@emotion/styled';
import logoImageDark from 'assets/images/start/logo_dark.png';
import IosGuide from './IosGuide';
import AndroidGuide from './AndroidGuide';
import { checkLoginState } from 'utils/checkLoginState';
import { getRuntimeEnv } from 'utils/runtimeEnv';

let isInited = false;

const AnotherClassLogoImage = styled('img')`
  width: 250px;
  height: auto;
`;

function Check() {
  const [isNativeOrStandAlone, setIsNativeOrStandAlone] = useState(true);
  const { palette } = useTheme();

  const env = getRuntimeEnv();
  const { os, userAgent, isStandalone, isNativeAndroidApp } = env;

  useEffect(() => {
    if (isInited) return;
    isInited = true;

    // ✅ iOS/Android는 “홈화면(PWA)” 또는 “네이티브 앱”일 때만 통과
    if (os === 'ios') {
      if (isStandalone) checkLoginState();
      else setIsNativeOrStandAlone(false);
      return;
    }

    if (os === 'android') {
      if (isNativeAndroidApp || isStandalone) checkLoginState();
      else setIsNativeOrStandAlone(false);
      return;
    }

    // ✅ 그 외(PC 등)는 그냥 통과(원래 정책 유지)
    checkLoginState();
  }, [os, isStandalone, isNativeAndroidApp]);

  if (isNativeOrStandAlone) {
    return (
      <Box
        component="main"
        sx={{
          width: '100%',
          backgroundColor: 'background.paper',
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Button
          variant="contained"
          onClick={() => {
            self.location.href = '/signIn';
          }}
        >
          로그인 화면으로 이동
        </Button>
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        width: '100%',
        backgroundColor: 'background.paper',
        flexDirection: 'column',
        minHeight: '100vh',
        paddingTop: '40px',
        paddingBottom: '40px',
        display: 'flex',
        justifyContent: 'flex-start',
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          mb: 4,
          px: 4,
        }}
      >
        <AnotherClassLogoImage src={logoImageDark} />
        <Typography variant="h5" color={palette.text.primary} mt={2}>
          어나더클래스 출결앱
        </Typography>

        <Typography variant="subtitle1" color={palette.text.primary} mt={2}>
          감사합니다! 어나더클래스 출결앱을 모바일 기기 홈화면에 설치해 주세요!
        </Typography>
      </Box>

      {os === 'ios' ? <IosGuide /> : os === 'android' ? <AndroidGuide /> : null}
    </Box>
  );
}

export default Check;
